import React, { Component } from "react";

class NotImplemented extends Component {
  state = {};
  render() {
    return (
      <div className="site-section pt-aftermenu">
        <div className="container col-md-12">
          <div className="col-md-12">
            <h1>Esta sección no está implementada</h1>
          </div>
        </div>
      </div>
    );
  }
}

export default NotImplemented;
